import {baseApi, ApiTags} from "../../../app/api/baseApi";

type UpdateCurrentGroupResponse = {
    data: {
        currentGroupId: number;
    };
};

export const usersApiSlice = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        updateCurrentGroup: builder.mutation<UpdateCurrentGroupResponse, { groupId: number }>({
            query: ({groupId}) => ({
                url: `/api/v1/users/current_group`,
                method: "PATCH",
                body: {groupId},
            }),
            invalidatesTags: [
                ApiTags.CreationsList,
                ApiTags.DraftsList,
                ApiTags.MediabankResourcesList,
                ApiTags.VoohList,
                ApiTags.VoohDetails,
                ApiTags.EmissionsList,
            ],
        }),
    }),
});

export const {useUpdateCurrentGroupMutation} = usersApiSlice;
